import { IDictionary } from "./common.interfaces";

export interface IPlaque {
  contributorsEmailMapName: IDictionary<string, string>;
  plaqueName: string;
  id: number;
  uniqueID: string;
  communityId: number;
  itemDisplayId: string;
  campaignName: string;
  campaignDisplayId: string;
  itemName: string;
  itemId?: number;
  itemLocationName: string;
  campaignId?: number;
  highLevelTypeId: number;
  highLevelTypeName: string;
  purchasedDate?: Date;
  plaqueDetailSubmittedDate?: Date;
  lastModifiedDate?: Date;
  contribution: Contribution;
  activationStatus: number
} 

export interface Contribution {
    name: string[];
    email: string[];
  }